import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export const getNewHiddenEntitiesIds = (type: EEntityType, v: boolean, filterIds: string[]) => {
  const currentIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(type);
  if (v) {
    const result: string[] = [];
    const filterSet = new Set(filterIds);
    for (const id of currentIds) {
      if (!filterSet.has(id)) result.push(id);
    }
    return new Set(result);
  } else {
    return new Set([...currentIds, ...filterIds]);
  }
};

export const getShouldUpdateIds = (type: EEntityType, v: boolean, targetIds: string[]) => {
  const currentIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(type);
  if (type === EEntityType.EMPTY) return [];
  const result: Set<string> = new Set();
  for (const id of targetIds) {
    if (v) {
      if (currentIds.has(id)) result.add(id);
    } else {
      if (!currentIds.has(id)) result.add(id);
    }
  }
  return Array.from(result);
};
